export default __webpack_public_path__ + "static/opengraph-img-943a1d77efe2433dedcd6c2b7916667e.png";